/**
 * Layout for /preview/photos only. Live Layout.tsx is untouched.
 */

import { ReactNode } from 'react';
import FloatingContactButton from './FloatingContactButton';
import PreviewBanner from './preview/PreviewBanner';
import PreviewHeader from './preview/PreviewHeader';
import PreviewFooter from './preview/PreviewFooter';

export default function PreviewLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col bg-white">
      <PreviewBanner />
      <PreviewHeader />
      <main className="flex-grow">{children}</main>
      <PreviewFooter />
      <FloatingContactButton />
    </div>
  );
}
